export default "__VITE_ASSET__kEgZJPy6__"